require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./toutes-les-actualits-epfl-0-6-0.json") })
        }
      }, "path---toutes-les-actualits-epfl-0-6-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---toutes-les-actualits-epfl-0-6-0!./.cache/json/toutes-les-actualits-epfl-0-6-0.json
// module id = 592
// module chunks = 231608221292675